export default __webpack_public_path__ + "static/media/logo-regenesis.48b069d1.svg";